module.exports = __webpack_public_path__ + "images/chad_o.jpg";